import { jsx as _jsx } from "react/jsx-runtime";
import { faAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown';
import { faAngleUp } from '@fortawesome/pro-light-svg-icons/faAngleUp';
import { Icon } from 'src/shared/components/icon';
const MobileArrow = ({ isExpanded, onClick }) => {
    return (_jsx("div", { className: "mt-1 flex items-center justify-center border-t-small border-neutral-200 p-3 md:hidden", onClick: onClick, children: _jsx(Icon, { icon: isExpanded ? faAngleUp : faAngleDown }) }));
};
export default MobileArrow;
